var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient795"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5dfff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient783"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f50",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient746",
    y2: 102.99,
    xlinkHref: "#linearGradient783",
    gradientUnits: "userSpaceOnUse",
    x2: 228.97,
    gradientTransform: "matrix(.74087 0 0 1.3286 40.513 .0061069)",
    y1: 102.99,
    x1: 215.83
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient747",
    y2: 173.45,
    xlinkHref: "#linearGradient783",
    gradientUnits: "userSpaceOnUse",
    y1: 218.47,
    gradientTransform: "matrix(1.5101 0 0 .65184 40.513 .0061069)",
    x2: 110.94,
    x1: 109.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient748",
    y2: 337.23,
    gradientUnits: "userSpaceOnUse",
    y1: 316.38,
    gradientTransform: "matrix(1.2315 0 0 .79928 40.513 .0061069)",
    x2: 126.02,
    x1: 125.91
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b50000",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc500",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient794",
    y2: 1003.7,
    xlinkHref: "#linearGradient795",
    gradientUnits: "userSpaceOnUse",
    y1: 1040.4,
    gradientTransform: "matrix(2.5627 0 0 .38409 40.513 .0061069)",
    x2: 78.221,
    x1: 117.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient800",
    y2: 226.38,
    xlinkHref: "#linearGradient795",
    gradientUnits: "userSpaceOnUse",
    y1: 245.98,
    gradientTransform: "matrix(.88634 0 0 1.1105 40.513 .0061069)",
    x2: 255.03,
    x1: 264.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient801",
    y2: 147.35,
    xlinkHref: "#linearGradient795",
    gradientUnits: "userSpaceOnUse",
    y1: 149.38,
    gradientTransform: "matrix(.55904 0 0 1.7607 40.513 .0061069)",
    x2: 456.4,
    x1: 407.87
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 375,
    fill: "#00247d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75595 0 0 .75595 0 -.000017730)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.2677 0 0 8.2677 0 .000022888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v3.3541l53.292 26.646h6.708v-3.354l-53.292-26.646h-6.708zm60 0v3.354l-53.292 26.646h-6.708v-3.354l53.292-26.646h6.708z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 0v30h10v-30h-10zm-25 10v10h60v-10h-60z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 12v6h60v-6h-60zm27-12v30h6v-30h-6z",
    fill: "#cf142b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 30l20-10h4.472l-20 10h-4.472zm0-30l20 10h-4.472l-15.528-7.7639v-2.2361zm35.528 10l20-10h4.472l-20 10h-4.472zm24.472 20l-20-10h4.472l15.528 7.764v2.236z",
    fill: "#cf142b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.621 0 0 0.621 461.4 21.482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m146.97 393.04s-3.35 8.84-5.26 8.84-8.84-3.82-8.84-3.82-5.02 8.13-7.65 8.6c-2.63 0.48-9.56-1.19-9.56-1.19s-6.69 0-6.93-0.96c-0.24-0.95 0.24-2.86 0.24-2.86s-9.558 7.64-11.709 7.16c-2.151-0.47-9.32-9.55-9.32-9.55l-1.195 4.78-13.621-0.48-11.949-7.65s-6.691 10.99-6.93 10.75-11.709 2.63-11.709 2.63l-0.717-2.15-7.647-4.54s5.974-8.36 5.974-8.6-2.868-1.2-2.868-1.2l-4.301 3.59-8.842 5.73-8.842-4.06 3.824-7.17 0.478-5.26 6.93-10.51 84.834-82.45 41.82 77.19-6.21 23.18z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#6a4c2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.24 398.04l22.08-0.8-9.4-4.64 84.14-3.17-11.89-4.53-10.53-14.27-43.6-3.28s-3.28-2.49-8.61-1.25c-0.22-3.39-4.3-7.81-4.3-7.81l-26.84-2.04-16.76 11.44 11.32 28.99 14.39 1.36z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.32 150.76l2.22-7.56s3.89-6.56 3.89-9.46c0-2.89 2.9-6.33 2.9-6.33s8.89-2.56 10.78 2.89c9.57-14.46 20.8-0.67 20.8-0.67l3.11-3.67 6.34-7.78s9.01 8.45 9.12 9.89c0.11 1.45 1.55 0.45 1.55 0.45l9.79-0.78s4.64 3.64 3.67 10.56c3.45 2.04 6.56 14.01 6.56 14.01l-80.73-1.55z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#linearGradient747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.25 240.72c1.69-1.03 7.01-2.72 6.36-10.5s-7.39-8.69-11.15-8.43c-3.77 0.26-7.14 3.5-7.14 3.5l-12.45-7.91s6.23-39.3 12.84-41.76c6.28-4.53 7.39-6.49 7.39-7.52 0-1.04-2.33-3.64-2.33-3.64l-40.6-4.8-38.39 4.54s-2.98 4.54-2.59 6.36c0.39 1.81 0.52 3.76 7.39 9.08 7.61 5.85 12.84 39.43 12.84 39.43s-10.76 5.31-11.41 4.66c-0.65-0.64-3.89-1.29-5.58-1.03-1.68 0.26-7.26 3.11-7.26 10.5 0 7.4 5.58 11.68 5.58 11.68s36.7-4.28 42.15 5.83c5.32-12.19 40.2-7.91 44.35-9.99z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#656263"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m246.79 199.87s0.41-4.27 3.45-6.3c3.05-2.03 23.36-3.05 28.24 0 4.87 3.05 6.7 18.08 6.7 18.08s3.05 5.28 3.25 9.14 0.61 6.5 0.61 6.5 16.25 21.13 16.45 40.22c1.83 13 1.42 47.73-3.65 60.93-0.21 16.46-7.11 27.22-7.11 27.22s1.62 2.84 1.42 5.89c-0.21 3.05-1.83 5.89-1.83 5.89l23.76 11.78-8.73-3.25s8.94 7.52 8.73 7.32c-0.2-0.21-9.95-4.68-9.95-4.68l5.89 5.89c-0.2-0.2-14.42-6.5-14.42-6.5s6.7 6.3 6.3 6.1c-0.41-0.2-10.77-5.08-10.77-5.08s6.5 6.91 6.3 6.5-9.34-4.06-9.34-4.06l0.4 3.45s-7.31-0.41-7.31-5.89c-3.66-2.03-6.09-4.88-6.09-4.88l-16.86-2.84-19.1-57.08 4.47-96.48 1.22-4.87-2.03-13z",
    strokeOpacity: 0.97854,
    stroke: "#000",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: ".99323pt",
    d: "m234.03 508.2s-9.78-20.57-14.65-20.86c-4.4-8.39 15.29-76.96 53.38-80.87 20.94 1.72 1.72 24.14-12.05 17.24 1.72 6.03 8.6 14.66 8.6 14.66s-27.25 11.78-35.28 69.83z",
    stroke: "#000",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.91 511.2s8.1-23.42 13.01-23.71c4.92-0.29-13.01-78.05-52.032-78.63-21.104 1.74-1.735 24.28 12.141 17.34-1.734 6.08-8.672 14.75-8.672 14.75s27.463 11.85 35.553 70.25z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.71 364.93c-0.1-0.19-9.69 3.01-3.48 13.45 0.47-4.04 4.79-6.49 4.79-6.49s-6.58 7.81 0.38 14.39c0.85-6.21 4.8-8.18 4.8-8.18s-4.89 14.39 0.09 17.3c0.57-5.74 4.23-8.27 4.23-8.27s-4.42 12.88-0.47 15.79c0.47-4.88 3.76-7.05 3.76-7.05s-1.97 13.36 3.2 14.3c0.1-4.71 3.86-9.31 3.86-9.31s-1.7 10.9 6.39 11.38c0.1-4.14 1.6-8.84 1.6-8.84s3.67 11.56 9.03 9.68c-0.09-3.38 0.09-9.78 0-9.78-0.1 0 3.38 11 9.78 8.94-0.94-3.11 0.37-6.78 0.37-6.78s3.39 6.87 9.5 4.61c1.04-2.07-0.28-6.11-0.28-6.11s8.93 9.22 11.66 3.67-7.15-7.43-7.15-7.43h6.68s-2.16-5.64-11.19-6.87c3.1-1.41 6.3-0.37 6.3-0.37s-1.88-7.06-11.1-7.81c3.58-1.22 7.53-0.37 7.53-0.37s-1.23-6.68-11.38-8.56c1.6-1.79 5.92-1.22 5.92-1.22s-4.04-6.3-8.65-5.93c-4.61 0.38-46.27-4.23-46.17-4.14z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00713d"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.25,
    strokeLinecap: "round",
    stroke: "#3ec26d",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.8 398.88s3.67 1.79 3.58 3.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.97 395.97s4.7 3.29 4.61 5.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.1 394.27s3.77 2.35 3.95 6.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.4 395.78s1.89 4.04 1.23 4.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.17 397.94c0.28 3.2-0.29 3.48-0.29 3.48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m149.8 377.72s4.42 2.82 4.05 6.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.52 381.11s2.07 1.97 1.6 3.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.98 377.82s2.91 4.04 1.97 6.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.96 380.45s1.32 2.54 0.1 3.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.31 381.67s1.6 2.54 0.19 3.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.53 390.04s4.13 0.94 4.7 4.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.97 387.22s4.33 0.28 4.8 4.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.71 385.62c0.09 0 2.91 4.99 2.44 6.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.26 386.09s1.12 4.8 0.28 6.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.83 387.97c0 0.1 0.09 5.55 0.09 5.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.38 380.45s2.72 1.03 2.53 3.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.91 378s3.48 1.98 3.11 5.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.96 376.41s3.01 3.57 1.88 7.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.22 377.25s-1.12 4.42-0.66 6.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.42 380.26s-1.97 1.51-0.94 3.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.31 397.47s0.65 3.39 0 3.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.98 395.5s2.16 3.76 1.41 5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.37 395.31s2.45 2.82 2.35 5.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.61 395.87s2.26 2.17 2.07 3.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.64 399.16s2.16 2.26 2.06 2.73"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m108.86 244.78c10.37-0.19 20.74-0.37 31.11-0.56 0 0 20.55 0 22.77 6.67 3.89-8.89 21.66-8.33 21.66-8.33 10.74-0.37 21.48-0.74 32.21-1.11 0.19 25.92 0.37 51.84 0.56 77.76-6.29 30.17-28.14 51.47-52.21 60.54-28.7-9.26-46.84-33.51-52.76-61.1-1.12-24.62-2.23-49.25-3.34-73.87z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.94 244.49l45.31 120.74 40.93-123.37c-12.7 0.82-39.94-2-43.32 9.58-5.24-10.36-33.9-6.18-42.92-6.95z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#006b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.78 309.86c1.75 0.91 1.7-32.77 3.99-33.81 0.65-2.79 0.98-4.01 1.8-6.97-1.97-3.49-10.79-3.32-14.06-0.35 1.47 4.7 2.12 6.27 2.12 6.27 4.42 7.15 3.54 35.62 6.15 34.86z",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 0.68918,
    fill: "#ffc900"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m138.64 49.548s3.21-3.638 3.35-4.51c0.15-0.873 14.55-1.455 23.13-17.458 4.8-8.438 0-3.492 0-3.492l-0.29-4.074s5.97-5.673 3.79-8.729c-2.19-3.0546-1.46 3.929-4.95 3.783s-1.6-7.565-1.6-7.565-0.29-0.873-1.31-1.3094c-1.46 0.1455-1.02 2.7642-2.33 3.0551-1.31 0.291-2.47-6.1103-2.47-6.1103s-2.18-2.9096-4.08 6.2558c1.02 9.7478 7.28 7.8558 7.28 14.258 0 6.401-5.53 11.347-7.13 11.493-1.6 0.145-1.02-5.383-1.02-5.383s-0.87-2.619-1.45-2.619 3.2-0.582 2.62-7.856c-1.31-8.729-2.33 2.037-4.66 1.6-2.33-0.436-0.58-8.001 0.29-8.874s-1.02-4.51-6.11 4.801c-0.44 4.51-1.02-1.164-2.04-0.873-1.74 3.637-1.45 6.256 1.02 9.602 3.64 3.346 5.97 6.692 5.82 8.438-0.14 1.746-2.04 5.674-4.65 5.674-2.62 0 0.14-4.801 0-6.402-0.15-1.6-4.51-7.419-4.51-7.419s-3.06-4.947-2.77-5.092c0.29-0.146-0.29-0.873-1.74 4.219-1.46 5.092-3.21-3.346-3.21-3.346s-2.03 6.255 2.33 10.038c-3.34-0.436-3.63 0.873-3.63 0.873 0 1.746 4.51 2.473 5.09 5.528 0.58 3.056-4.66 4.801-4.66 4.801s2.19 3.055 8.29-2.909c0.15 3.782-2.32 6.401-2.32 6.401 2.03 0.921 3.63 0.824 3.92 3.201z",
    stroke: "#000",
    strokeWidth: 1.25,
    fill: "#cdad56"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m118.68 49.548s-2.72-4.037-2.84-4.832c-0.13-0.794-13.38 1.004-19.648-15.158-4.078-7.678 0-3.177 0-3.177l0.247-3.707s-4.339-5.308-2.486-8.088 1.09 3.574 3.474 3.587c2.963-0.132 1.359-6.884 1.359-6.884s0.246-0.794 1.112-1.191c1.232 0.132 1.742 4.115 2.852 4.38s3.41-4.687 4.13-5.7054c1.02-0.1457 0.98-4.1023 2.59 4.2374-0.86 8.87-8.21 7.149-8.21 12.974 0 5.824 4.69 10.325 6.05 10.458 1.36 0.132 0.87-4.898 0.87-4.898s0.74-2.383 1.23-2.383c0.5 0-4.32 0.925-3.82-5.694 1.11-6.197 3.57 0.399 5.55 0.001 1.98-0.397-0.23-6.553 0.34-7.493 0.13-0.94 3.04-4.977 4.17 3.932 0.37 4.104 2.61-3.532 3.47-3.267 1.49 3.309-0.65 7.729-2.75 10.774-3.09 3.044-4.49 6.38-4.36 7.969 0.12 1.588 0.85 3.562 3.08 3.562 2.22 0 0.75-2.768 0.87-4.224s3.83-6.17 3.83-6.17c0.73-1.163 0.12-3.337 0.89-4.342 1.21 0.013 1.71-1.667 2.94 2.966 1.24 4.633 2.72-3.045 2.72-3.045s1.73 5.693-1.98 9.135c2.84-0.397 3.09 0.794 3.09 0.794 0 1.589-1.35 2.25-1.85 5.03s1.48 4.369 1.48 4.369-1.85 2.78-7.04-2.648c-0.13 3.442 1.98 5.825 1.98 5.825-1.74 0.839-3.09 0.75-3.34 2.913z",
    stroke: "#000",
    strokeWidth: 1.0989,
    fill: "#cdad56"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "1pt",
    d: "m198.62 262.5c-2.71-2.46-3.03-0.31-4.36-0.86-0.66-0.27-1.17-0.88-1.74-1.44-0.49-0.51-1.08-0.72-1.73-0.99-0.25 0.73-0.49 1.45-0.74 2.18s0.69 1.94 0.67 3.03c-0.19 1.62-0.85 2.97-2.89 3.52 0.58-1.15 0.91-1.2 0.73-2.61-0.08-0.7-2.05-1.95-1.81-2.61 0.36-1.07 0.98-2.3 0.52-3.37-0.83 0.57-1.93 0.27-2.76 0.62-0.71 0.31-0.75 1.62-1.73 2.16-1 0.47-3.21 0.24-5.06-0.81 1.13-0.85 2.06-0.28 3.19-1.13 0.56-0.43 0.54-2.26 1.1-2.69 0.57-0.43 1.92-0.88 2.48-1.31-0.51-0.58-0.48-1.49-0.99-2.07-0.5-0.58-2.75-0.46-3.26-1.03-1.02-1.16-0.82-2.68-1.84-3.83 2.63 0.94 2.25 2.22 2.91 2.12 1.24-0.6 2.48-0.71 3.13-0.44 0.66 0.28 1.9 1.9 2.55 2.17 0.25-0.73 0.61-1.65 0.85-2.38 0.25-0.73-1.1-1.99-0.86-2.72 0.5-1.45 1.72-2.74 2.21-4.2 0.18 1.41 0.41 2.59 0.59 3.99 0.09 0.7 1.47 1.07 1.56 1.77 0.09 0.71-0.72 2.33-0.64 3.04 0.76-0.15 1.85-0.05 2.6-0.2 0.76-0.15 1.26-1.9 2.01-2.05 1.51-0.3 2.6-0.21 4.13 0.08-1.13 1.05-2 0.98-2.71 1.94-0.56 0.43 0.22 1.84-1.41 2.83-0.61 0.36-2.22-0.07-2.79 0.36 0.51 0.58 1.02 1.15 1.53 1.73 0.5 0.58 2.78 0.85 3.29 1.43 1.01 1.15 1.55 2.53 1.27 3.77z",
    fill: "#ffc900"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "1pt",
    d: "m128.95 263.69c2.71-2.46 3.03-0.31 4.37-0.86 0.65-0.28 1.16-0.89 1.73-1.44 0.49-0.51 1.08-0.72 1.73-1 0.25 0.73 0.5 1.46 0.74 2.19 0.25 0.73-0.68 1.93-0.66 3.02 0.18 1.63 0.84 2.97 2.88 3.53-0.58-1.15-0.91-1.21-0.73-2.61 0.09-0.7 2.05-1.95 1.81-2.62-0.36-1.06-0.98-2.3-0.52-3.37 0.84 0.58 1.93 0.28 2.77 0.62 0.7 0.32 0.75 1.63 1.72 2.17 1.01 0.47 3.22 0.24 5.06-0.81-1.13-0.86-2.06-0.28-3.19-1.14-0.56-0.42-0.53-2.26-1.1-2.68-0.56-0.43-1.91-0.89-2.48-1.32 0.51-0.57 0.48-1.49 0.99-2.07 0.51-0.57 2.76-0.45 3.26-1.03 1.02-1.15 0.83-2.67 1.84-3.83-2.63 0.94-2.24 2.22-2.9 2.13-1.25-0.6-2.49-0.72-3.14-0.44-0.65 0.27-1.9 1.89-2.55 2.17-0.25-0.73-0.6-1.65-0.85-2.38s1.11-1.99 0.86-2.72c-0.49-1.46-1.72-2.74-2.21-4.2-0.18 1.4-0.41 2.58-0.59 3.99-0.09 0.7-1.47 1.07-1.56 1.77-0.08 0.7 0.73 2.33 0.64 3.03-0.76-0.15-1.85-0.05-2.6-0.19-0.75-0.16-1.25-1.91-2.01-2.06-1.51-0.3-2.59-0.21-4.13 0.08 1.13 1.06 2 0.98 2.71 1.95 0.56 0.43-0.22 1.84 1.41 2.83 0.61 0.36 2.23-0.07 2.79 0.36-0.51 0.57-1.02 1.15-1.52 1.73-0.51 0.58-2.79 0.85-3.29 1.42-1.02 1.16-1.56 2.54-1.28 3.78z",
    fill: "#ffc900"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m196.19 270.28c-2.46 1.91-18.31 5.92-18.48 19.69-0.16 13.77 2.78 16.91-0.16 17.26-5.72 0-6.54-15.34-6.38-22.14 0.17-6.8 0.33-5.75 0.33-5.75s3.92 1.04 3.6 4.36c-0.33 3.31 3.92-8.2 2.45-11.33 2.61 2.61 6.05 1.57 6.05 1.39 0-0.17-1.96-2.26-2.78-3.83s2.94 0.87 2.94 0.87 0.16-2.62-3.11-2.44c-4.25 0 0.66-1.4 0.66-1.4s2.45 2.27 4.09-0.17c-1.8-1.92-4.42-2.97-4.42-2.97s-2.29-4.35-5.39-5.22c-3.6-0.88-3.11 1.56-7.2 1.22-0.81 1.56-0.81 1.74 0.82 2.26-2.78 1.92-1.31 5.75-1.31 5.75s4.42-1.91 4.25 1.22c-0.16 3.14-2.61 2.62-4.25 0.7-1.47-0.87-1.96 0.87-1.96 0.87l2.29 2.44s-4.41-0.17-5.56 2.79c2.45-0.17 3.76 0.53 3.76 0.53s-5.07 2.26-5.56 3.48-0.65-1.39-0.81-1.39c-0.17 0-4.91-1.75-4.91-1.75l-1.64 7.54s3.28 3.27 5.07 2.22c1.8-1.04 5.07-4.18 7.03-3.31-5.72 4.36-11.44 10.63-14.55 11.51-0.81-0.7-3.59-3.49-4.74-2.1-1.14 1.4-0.32 3.14 1.15 2.97 1.47-0.18-4.74 1.39-3.44 4.01 1.31 2.61 1.15 2.44 2.29 1.74 1.15-0.7-0.98-0.87 3.27-2.09s4.09-2.44 4.09-2.44-0.82 1.91-3.11 2.44c-2.29 0.52-4.08 0.52-3.59 1.22 0.49 0.69 1.47 1.91 1.14 2.61s4.74-3.66 6.05-0.17c3.43-0.18 5.72-4.36 4.09-6.8 0.16 2.61 1.8 3.49 0.81 4.71-0.98 1.22 7.69-4.01 3.44-7.15 1.14 2.61 1.31 4.71 1.31 4.71s1.96-0.18 2.45-0.88c0.49-0.69-0.98 1.92-0.33 2.44 0.65 0.53 3.76 3.49 2.45 5.58-0.81-1.22-0.98-3.14-1.96-2.96-0.98 0.17-5.07 3.14-7.52 3.31s2.94 9.07 2.94 9.07-3.76-0.53-4.25-0.18-2.94-3.14-3.43-1.04c-0.82 2.61 0.82 1.56 0.82 1.56s-2.13-1.04-3.27 0.18c-1.15 1.22-2.29 2.44-1.47 2.96 0.81 0.52 4.41 0.52 4.9 0.35s-4.09 0.35-4.41 0.87c-0.33 0.52-0.98 2.44 0 3.14s3.43-0.35 3.59-0.87c0.17-0.53 0.33 1.91 0.33 1.91s4.25 0.35 4.25-4c0-4.36 0.33 3.13 0.33 3.13s4.25 0.7 4.41-3.66c0.17-4.35 0.49 2.97 0.49 2.97s2.78-0.88 2.78-1.57c0-0.7-0.16 8.71-2.12 11.33-3.11-2.1-5.07 1.39-5.07 1.39s0.16 5.05-0.17 6.27c-0.32 1.22 2.13-0.69 2.29-1.22 0.17-0.52 3.11-1.91 3.27-2.26 0.17-0.35 0.98-2.09 0.98-2.09s-0.65 2.44-1.79 2.79c-1.15 0.34-2.29 1.56-1.8 2.61s2.29 1.74 2.94 2.79c0.65 1.04 2.94-6.1 2.94-6.1l0.17 1.57s2.94-0.7 3.27-2.09c0.32-1.4-3.11-2.62-0.33-4.88 2.78-2.27 0 2.09 0 2.09s0.98 3.31 1.63 3.31c0.66 0 2.29-6.28 0.66-7.84-1.64-1.57 2.45 1.91 2.45 1.91s2.29-6.45-0.16-7.32c-2.46-0.87-3.6-1.22-3.6-1.22s1.31-1.74 0.65-1.91c-0.65-0.18 3.44 3.83 4.09 2.78 0.66-1.04 1.64-4.18-3.1-5.92-4.75-1.74-0.17-6.63-0.17-6.63s2.95 3.49 5.07 1.57c2.12-1.91-0.16-1.91-0.16-1.91s6.04-3.84 6.21-5.76c-1.15-0.17-3.11 0.18-3.11 0.18s3.44-2.27 2.62-5.93c-1.31 1.92-3.11 1.92-3.11 1.92s2.95-2.96 2.45-5.75c-1.79 1.39-1.63 2.44-2.78 2.09-1.14-0.35-3.1-11.33 1.48-12.03 4.57-0.69 2.12 5.41 2.28 5.41 0.17 0 6.87-2.79 0-7.32 1.64-0.53 5.07 2.61 5.07 2.61s-1.47-7.67-8.83-2.96c1.8-1.92 2.95-3.14 4.42-2.79s6.7-0.18 6.7-1.74c-1.3-1.05-4.08 0.52-5.56 0-1.47-0.53 10.47-1.4 9.49-7.32z",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 0.68918,
    fill: "#ffc900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481.3 118.54s12.25-6.43 18.37 1.54",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.57 132.32c-0.31 0-4.29 3.98-5.21 3.98",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512.84 145.18s11.32 0.92 18.67-10.41",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.08 141.81s0.92 6.13 2.76 6.13c1.83 0-3.06 1.53-4.9 0.3 2.14 2.76 3.37 7.66 0 9.49",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519.26 218.97s-3.98 4.28-8.88 4.59",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m523.86 199.37s-2.45-12.24-0.92-15.31c0.92-3.98 4.9-5.51 7.96-10.71",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m522.63 190.49s-3.06 7.35-16.53 4.9",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.31 172.12s0.91 9.8-11.33 6.13",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.3 128.04s-4.9 4.28-3.06 10.1",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.67 117.32s6.43-2.45 7.66-3.68c1.22-1.22 3.37-3.67 3.98-5.51 0.61-1.83-4.29-4.59-1.84-8.569 1.53-1.837 3.67-2.143 7.35 0 3.67 2.139-3.37-6.735-7.04-7.041-3.68-0.307-6.13 2.449-7.04 1.836-0.92-0.612 0.3 2.45-1.23 2.45s3.06 2.449 2.76 3.984c-0.31 1.53 4.89 6.73 4.59 7.96-0.31 1.22-7.66 8.26-9.19 8.57z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "#006b00"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m534.27 97.112c2.79-0.636 3.24 0.07 2.75 2.449-1.31-0.66-1.79-1.217-2.75-2.449z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#ffc900",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "#ffc900"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m514.71 233.52s-1.03 6.41 1.49 6.94c-0.13-2.48 0.54-4.17 1.16-4.83-0.54-0.25-2.53-2.07-2.65-2.11z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: 1.25,
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m509.03 225.63c-2.32-0.33-6.23 1.59-5.11 3.91 1.89-1.62 3.63 0.13 4.95-1.52 0.4-0.46 0.29-1.81 0.16-2.39z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: 1.25,
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m509.01 221.05s-3.65-0.58-4.16 1.95c2.52-0.32 3.27-0.59 4.11-0.06 0.24-0.54 0.01-1.76 0.05-1.89z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: 1.25,
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m493.54 184.94s2.19 0.82 2.81 3.06c1.74-1.08 2.57-5.83-2.81-3.06z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m488.12 190.39c0.09-0.04 4.59-2.77 5.05-0.16-0.95 0.95-1.37 1.57-2.11 1.78-0.58 0-1.74-1.78-2.94-1.62z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m487.67 199.24c0.08-0.04 2.89-2.52 3.97-0.87 1.07 1.66-0.87 1.57-0.87 1.57s-0.99-0.45-3.1-0.7z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m483.7 149.96c-0.04 0-3.6-1.37-5.09 1.11 2.36 0.29 3.19 1.12 4.26 1.95-0.29-1.04-0.78-2.61 0.83-3.06z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m476.8 168.52s0.16-4.17 2.14-5.87c1.12 0.62 1.45 1.61 2.2 2.85-1.49 0.33-3.48 0.42-4.34 3.02z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m486.3 165.54s-3.92 1.82-2.64 3.81c1.28-1.37 2.69-0.95 2.69-0.99s0-2.77-0.05-2.82z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m480.64 125.6c-1.41 1.58 1.74 5.01 5.04 4.51 0.83-3.72-4.21-5.66-5.04-4.51z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#ffc900"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m480.6 118.41c-0.69 1.75 2.05 4.21 3.64 3.52 0.64-1.8-2.92-4.91-3.64-3.52z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m484.28 122.75s0.62 2.94 3.47 2.15c-0.45-2.27-2.44-3.97-2.44-3.97-0.12 0.67 0.41 1.7-1.03 1.82z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m486.18 131.27s1.57 1.69 4.67-1.78c-1.4 0.41-3.88-0.83-3.88-0.83s0 2.4-0.79 2.61z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m480.46 118.86c-1.4 1.57 0.59 3.76 3.89 3.27 0.83-3.72-3.06-4.42-3.89-3.27z",
    transform: "matrix(.53397 0 0 .56928 -112.64 207.32)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#ffc900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.62 266.62s7.04-2.01 10.78 1.01c3.73 3.01 3.73 0.28 3.73 0.28s5.46 2.01 7.04 1.58-1.15 0.15 1-1.15c2.16-1.29-4.31 0.29-4.88-2.44-1.01-1.72 0.14-3.88-2.15-3.16-1.58-2.01 1-3.44 0.43-5.6-1.58 1.15-2.45-0.43-3.74 2.44-3.01-0.57-0.43-4.74-3.73-5.17 0 3.02-2.44 3.16-2.59 4.89-1.43 1-7.75 4.74-5.89 7.32z",
    fill: "url(#linearGradient748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.624 495.58c4.566-1.1 29.306 5.47 38.846 15.69-2.03-18.21-7.072-32.16-7.072-32.16s-14.743-4.21-16.767-2.18c-2.968 3.12-11.883 12.49-15.007 18.65z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#c01500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.082 411.46c-1.734 0.29-3.469 1.45-5.203 4.34-2.024 4.91-3.469 17.34-6.36 20.23s-5.493 3.18-5.493 5.79c0 2.6 0.29 8.67 8.095 10.98 7.805 0.29 20.236-12.43 20.236-12.43s6.36-6.94 8.961-14.45c-15.032 5.2-25.728-8.68-20.236-14.46z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#c01500"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: ".99323pt",
    d: "m273.49 492.68c-4.53-1.09-29.55 5.44-39.02 15.6 2.01-18.1 7.02-31.98 7.02-31.98 1.75-0.47 14.47-4.18 16.48-2.16 2.94 3.1 12.42 12.42 15.52 18.54z",
    stroke: "#000",
    fill: "#c01500"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: ".99323pt",
    d: "m280.5 409.05c1.72 0.29 2.33 2.55 3.74 5.43 2 4.88 4.07 12 6.94 14.87 2.87 2.88 5.45 7.13 5.45 9.72s-0.6 6.08-8.35 8.38c-7.74 0.29-18.97-9.66-18.97-9.66s-6.31-6.89-8.89-14.37c14.92 5.18 24.58-8.14 20.08-14.37z",
    stroke: "#000",
    fill: "#c01500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.41 479.69s15.61 10.69 15.9 15.61c41.92-62.16 148.88-81.53 209.87-4.34 8.1-10.7 16.48-14.16 16.48-14.16-64.17-83.84-191.95-73.43-242.25 2.89z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    transform: "translate(-.0000071526 .000045776)",
    stroke: "#000",
    fill: "#1e5aa6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m206.44 241.88l6.11-0.15-10.91 13.82 13.09 15.28-25.75 32.44 24.3 29.24c-2.67 6.55-5.77 12.51-9.9 17.9l-13.96-15.43 25.31-31.56-20.8-23.57 12.51-37.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.15 244.64l-6.55 0.15 12.22 13.23-12.94 16.15 26.91 29.25-22.26 29.82c2.67 6.55 6.5 13.82 10.62 19.2l13.24-16.73-27.2-30.26 19.93-25.31-13.97-35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.41 323.2l-9.6 12.8 34.33 39.72c6.06-3.06 10.82-6.55 16.01-10.76l-17.9-20.66 7.28-21.39 10.47 12.07-32.73 41.76c-5.48-2.33-11.54-5.97-17.02-10.48l17.31-21.96-8.15-21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.79 303.27l6.26 7.86-4.08-10.62-2.18 2.76z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: ".96849pt",
    d: "m183.6 310.22c0.13-0.15 5.05-6.7 5.05-6.7l-1.91-2.61-3.14 9.31z"
  })), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Timmons",
    fontSize: "14px",
    fontWeight: "bold",
    "line-height": "100%"
  }, /*#__PURE__*/React.createElement("text", {
    y: 362.39716,
    x: -328.34363,
    transform: "rotate(-49.557)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 362.39716,
    x: -328.34363
  }, "L")), /*#__PURE__*/React.createElement("text", {
    y: 384.26642,
    x: -292.33514,
    transform: "rotate(-45.392)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 384.26642,
    x: -292.33514
  }, "E")), /*#__PURE__*/React.createElement("text", {
    y: 451.6806,
    x: -239.78038,
    transform: "matrix(.76280 -.54464 .56769 .75422 0 0)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 451.6806,
    x: -239.78038
  }, "O")), /*#__PURE__*/React.createElement("text", {
    y: 429.95776,
    x: -188.5262,
    transform: "matrix(.82844 -.56007 .56007 .82844 0 0)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 429.95776,
    x: -188.5262
  }, "T")), /*#__PURE__*/React.createElement("text", {
    y: 451.47876,
    x: -115.42612,
    transform: "rotate(-25.549)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 451.47876,
    x: -115.42612
  }, "E")), /*#__PURE__*/React.createElement("text", {
    y: 453.04584,
    x: -94.110794,
    transform: "rotate(-23.988)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 453.04584,
    x: -94.110794
  }, "R")), /*#__PURE__*/React.createElement("text", {
    y: 454.98212,
    x: -68.37056,
    transform: "rotate(-21.911)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 454.98212,
    x: -68.37056
  }, "R")), /*#__PURE__*/React.createElement("text", {
    y: 445.66595,
    x: 112.01579,
    transform: "rotate(-4.7626)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 445.66595,
    x: 112.01579
  }, "R")), /*#__PURE__*/React.createElement("text", {
    y: 430.7926,
    x: 180.22531,
    transform: "rotate(.85649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 430.7926,
    x: 180.22531
  }, "R")), /*#__PURE__*/React.createElement("text", {
    y: 275.21735,
    x: 414.75919,
    transform: "rotate(29.645)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 275.21735,
    x: 414.75919
  }, "R")), /*#__PURE__*/React.createElement("text", {
    y: 193.05025,
    x: 483.87762,
    transform: "rotate(39.802)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 193.05025,
    x: 483.87762
  }, "E")), /*#__PURE__*/React.createElement("text", {
    y: 414.02829,
    x: 309.11557,
    transform: "matrix(.96356 .18112 -.15531 .95184 0 0)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 414.02829,
    x: 309.11557
  }, "O")), /*#__PURE__*/React.createElement("text", {
    y: 459.27182,
    x: 105.05786,
    transform: "matrix(.90188 -.13160 .13648 0.975 0 0)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 459.27182,
    x: 105.05786
  }, "O")), /*#__PURE__*/React.createElement("text", {
    y: 455.83463,
    x: -45.707756,
    transform: "rotate(-20.292)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 455.83463,
    x: -45.707756
  }, "A")), /*#__PURE__*/React.createElement("text", {
    y: 144.72449,
    x: 518.34955,
    transform: "matrix(.70468 .70952 -.70952 .70468 0 0)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 144.72449,
    x: 518.34955
  }, "A")), /*#__PURE__*/React.createElement("text", {
    y: 388.29758,
    x: 271.18784,
    transform: "matrix(.98042 .19691 -.19691 .98042 0 0)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 388.29758,
    x: 271.18784
  }, "A")), /*#__PURE__*/React.createElement("text", {
    y: 455.1676,
    x: 40.321587,
    transform: "rotate(-10.645)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 455.1676,
    x: 40.321587
  }, "M")), /*#__PURE__*/React.createElement("text", {
    y: 448.07883,
    x: 94.428757,
    transform: "rotate(-5.9402)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 448.07883,
    x: 94.428757
  }, "P")), /*#__PURE__*/React.createElement("text", {
    y: 437.60687,
    x: 155.08846,
    transform: "rotate(-1.4626)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 437.60687,
    x: 155.08846
  }, "P")), /*#__PURE__*/React.createElement("text", {
    y: 276.66531,
    x: 405.13382,
    transform: "rotate(29.499)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 276.66531,
    x: 405.13382
  }, "P")), /*#__PURE__*/React.createElement("text", {
    y: 409.79309,
    x: 232.09538,
    transform: "matrix(.99340 .11468 -.11468 .99340 0 0)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 409.79309,
    x: 232.09538
  }, "I")), /*#__PURE__*/React.createElement("text", {
    y: 132.08934,
    x: 530.39215,
    transform: "rotate(46.586)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 132.08934,
    x: 530.39215
  }, "T")), /*#__PURE__*/React.createElement("text", {
    y: 218.51869,
    x: 464.15771,
    transform: "rotate(36.816)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 218.51869,
    x: 464.15771
  }, "T")), /*#__PURE__*/React.createElement("text", {
    y: 361.96112,
    x: 313.72498,
    transform: "rotate(16.412)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 361.96112,
    x: 313.72498
  }, "M")), /*#__PURE__*/React.createElement("text", {
    y: 123.24773,
    x: 513.7041,
    transform: "rotate(47.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 123.24773,
    x: 513.7041
  }, "G"))), /*#__PURE__*/React.createElement("g", {
    stroke: "#fff700",
    strokeLinecap: "round",
    strokeWidth: "1pt",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m255.94 200.94s6.04-5.17 10.34-5.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.81 200.22c0.14-0.14 36.05-5.17 37.19-6.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.95 200.51c0.14-0.15 40.21-3.45 40.21-3.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.81 200.65s42.65-2.01 45.24 0.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.66 200.51s41.8 0.29 42.52 1.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.81 200.51l40.21 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.38 200.8c0.14 0 40.93 3.59 44.95 8.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.48 216.88c-0.14-0.14-13.93-16.52-47.25-16.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.38 200.94s23.12 1.58 30.44 9.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.81 200.65s14.93-2.87 30.59 15.95"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m247.4 217.74s20.72 0.82 20.72 2.85-15.44 5.89-15.64 14.42 11.78 9.14 12.59 19.9c0.81 10.77-9.34 12.39-11.37 15.24-2.04 1.42-6.91 16.65-6.3 25.59s3.25 39.2 7.92 45.3c3.66 2.84 9.14 11.98 15.03 9.14 5.89-2.85 1.83-13.2 1.22-16.05-0.61-2.84 2.44-7.51 2.44-11.78s-2.24-7.72-2.03-8.73c0.2-1.02 16.45 3.86 15.43 19.9-1.01 16.05-7.51 11.17-7.51 11.17s2.03 19.71-3.05 22.35c-9.14 4.87-15.84-1.02-15.84-1.02l0.86 4.01-6.95-3.6s-8.94-12.8-10.97-18.49c-2.03-5.68-4.47-31.07-3.66-36.56 0.81-5.48 1.42-37.58 1.02-39.2-0.41-1.63-2.03-28.44-1.02-32.5 1.02-4.06 7.31-21.94 7.11-21.94z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#linearGradient801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.06 212.46s14.42-14.01 22.75-12.39c4.26 0 0.2 3.05 0.2 3.05s7.31 0.61 8.33 3.86c0.2 1.42-3.46 1.83-3.46 1.83s3.05 0.61 3.25 3.25c0.21 2.64-30.87 0.6-31.07 0.4z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff7000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.87 211.85s15.44-2.03 21.94-8.53",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.51 207.59s11.37-0.41 11.37 1.22",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m281.93 373.74s9.75-2.24 12.39-5.69c1.63-1.22 10.16 12.8-12.39 5.69z",
    stroke: "#000",
    strokeWidth: 1.25,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.29 293.1s1.22 7.52-2.23 12.59c-1.83 2.03-7.32 5.49-7.32 7.93 0 2.43 2.03 5.68 1.63 8.53-0.41 2.84-3.45 5.69-3.25 8.12 0 2.44 3.45 15.44 3.04 15.64",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.42 268.73s-7.72 2.64-9.35 10.36",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.16 207.59s2.65 7.31 11.18 0.4c-5.49-7.51-11.18-0.2-11.18-0.4z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#c75b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.87 206.47c0 0.39265-0.40924 0.71095-0.91405 0.71095s-0.91405-0.3183-0.91405-0.71095c0-0.39264 0.40924-0.71094 0.91405-0.71094s0.91405 0.3183 0.91405 0.71094z",
    transform: "translate(-.40625 .8125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.41 190.62s16.18 17.51 26.65 17.32c1.9 5.14-4.76 9.92-7.42 12.2-5.33-1.71-10.15 0.31-22.52-14.91 0.77-9.71 3.48-14.23 3.29-14.61z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.3 149.89c2.09-6.47 6.28-11.61 9.89-12.18-0.95-4.95 7.62-26.83 32.55-35.21 1.52 11.23-10.66 22.27-10.66 22.27s36.73-6.28 44.15-15.61c-0.76 4.19-8.18 30.26-47.39 30.07 14.85 14.09-4.75 25.32-13.13 21.89 15.42-11.8-4.37-18.84-15.41-11.23z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.86 140.76c7.42-4.76 10.08-4.76 16.18-3.81-4.38 0.57-4.38 0.76-4.38 0.76s-0.38 0.57 2.28 3.05c-3.04-0.77-5.71-2.48-14.08 0z",
    stroke: "#CCC",
    strokeWidth: "1pt",
    fill: "#cccccd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220 137.71s14.66-7.8 22.84-13.13",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.44 220.12s20.18 5.52 22.46-23.41c-4.38-12.56-10.47-39.59-1.14-47.39-8.57-5.9-17.89 0.19-17.89 0.19-0.57 1.33-8.19 12.18 2.09 31.21-24.36-6.47-14.46 16.56-14.46 16.56 0.95-3.62 13.89-7.04 17.13 11.42 1.33 4.57-8.76 11.61-8.19 11.42z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.09 196.9s21.32-11.42 20.74-38.25c-18.08 0.38-24.55 23.78-24.55 23.78l3.81 14.47z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.55 195.57s-15.79 13.7-24.74 9.32c-6.66 4-14.462-3.04-14.462-3.04s9.132 33.68 41.872 9.32c-0.57-7.42-2.29-15.03-2.67-15.6z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.62 204.32c1.33-7.04 6.85-10.47 11.23-3.81 5.9 1.15 11.8-23.02-9.14-19.03 5.9-31.59-11.795-43.39-11.795-43.39s-6.28 35.02-3.426 41.49c2.855 6.47-4.186-11.99-26.834-17.13-0.381 26.46 25.312 38.83 25.312 38.83s7.233 6.66 14.653 3.04z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.71 181.29s-9.89 8.38-7.61 19.8",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.68 180.15s-2.284 8.18 2.664 19.79",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.157 202.61s4.568-7.42 14.463 2.09",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.06 151.22c0-0.19-15.034 0-6.09 15.23-6.661 2.09-21.505-7.61-11.228-20.56-33.686-0.76-47.389-16.93-47.389-31.78 9.897 10.28 33.496 6.09 41.87 12.37-10.277-9.51-8.184-22.65-8.184-22.65s28.738 8.57 33.876 34.07c-1.713 4.95-2.474 13.7-2.855 13.32z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.942 125.82c5.546 5.64 19.795 7.33 27.028 13.61",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.94781,
    d: "m80.503 142.47s11.797-1.52 15.216 2.66c-4.616 0-6.155-1.14-12.822 1.34 1.88-0.96 1.367-2.67 2.393-2.67s-4.274-1.33-4.787-1.33z",
    stroke: "#CCC",
    fill: "#cccccd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.31 50.166s6.47-5.71 13.51-0.571c-3.18 9.507-14.65 5.9-14.65 5.9s0.38 4.758-0.76 7.041c2.29 1.727 4.18 7.423 4.18 7.423s11.8-2.855 14.28 2.284c4.52-0.624 7.8 0 7.8 0s9.14-2.284 12.37-2.284c3.24 0 13.51 2.664 14.46 4.567 0.96 1.903 4.38 14.655 6.67 14.464 2.28-0.19-5.52 3.045-7.62-0.19-2.09-3.236-1.52 4.187-1.52 4.187s6.47 6.851 7.23 8.373c0.76 1.52-3.99 13.89-0.38 22.46-3.17 0.29-3.42 3.61-3.42 3.61-0.18 3.77-4.95 4.76-4.95 4.76l-1.14-5.14-3.24 1.91 1.33-4s4.38-10.66 4.76-14.08c0.38-3.43-4-9.52-7.42-9.52-3.43 0-5.9 10.85-5.9 10.85s-1.71 8.18-1.14 8.94-2.29-2.66-2.29-2.66-1.52 4.95-2.66 6.47-3.62 2.09-3.62 2.09-1.71-4.95-1.14-6.85 9.33-9.32 8.57-14.65c-0.77-5.33 0-4-0.2-4.19-0.19-0.19-4.56-3.996-4.75-6.089-0.19-2.094-5.71 2.664-12.94 1.141-2.22 3.868-2.48 13.508-2.48 13.508s-0.76 11.61 0.76 12.95c1.53 1.33-3.8 4.18-3.8 4.18l-3.81 5.14s-1.33-3.23-1.33-3.04-2.67 1.9-2.67 1.9l1.53-3.81c-0.1-2.88 3.7-10.75 3.7-17.41s0.48-13.798 0.48-13.798-7.04-0.381-6.85 6.848c0.19 7.24-1.71 7.62-1.33 9.71s2.28 7.99 1.71 9.71c-0.57 1.71-2.85 2.28-2.85 2.28l-0.57 0.95s-7.04 3.24-6.85 4.57-0.19-3.81-0.19-3.81l-0.39-5.52s4.19-2.66 4.19-9.32-0.96-7.61-0.77-9.13c0.19-1.53 1.15-7.05 0.96-7.62-0.19-0.571-3.99 1.522-5.14 1.522-1.14 0 2.1-3.996 2.48-6.851s-3.81 2.664-7.23-0.571c1.59-3.514 3.99-4.568 4.37-7.232s-2.66 2.284-5.33 0.381c0.22-2.554 2.86-4.758 2.86-4.758s-2.17-0.266-3.05 0c-1.71-0.571 1.91-3.236 2.1-7.042s-2.1-5.329-2.1-5.519-3.8-3.426-4.37-4.758-0.57-2.855-0.57-2.855-6.29 4.568-13.71-5.138c6.8-5.803 14.09-1.523 14.09-1.523s1.9-5.329 10.65-4.948c8.76 0.381 10.47 5.329 10.09 4.758z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#923f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.19 148.61c0.15 0 16.16 0.48 16.32 9.04 0.16 8.55-4.91 6.34-5.07 6.34s-11.73-1.43-11.73-1.43l0.48-13.95z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.65 146.23s19.97-0.15 18.86 8.56c-1.11 8.72-6.18 6.98-6.18 6.98l-9.67-0.8-3.01-14.74z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fffeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.4 145.28l11.57 0.95s6.97 0.95 6.66 7.61c-0.32 6.66-7.14 6.82-7.14 6.82l-11.25-0.64 0.16-14.74z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.3 148.61c-0.16 0-16.17 0.48-16.33 9.04-0.15 8.55 4.92 6.34 5.08 6.34s11.73-1.43 11.73-1.43l-0.48-13.95z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.83 146.23s-19.97-0.15-18.86 8.56c1.11 8.72 6.18 6.98 6.18 6.98l9.67-0.8 3.01-14.74z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.09 145.28l-11.57 0.95s-6.98 0.95-6.66 7.61 7.13 6.82 7.13 6.82l11.25-0.64-0.15-14.74z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.07 241.51s8.32-12.26 11.83-10.95c3.06 1.02 0.73 10.51-0.73 11.39l-11.1-0.44z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#5e0043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.04 243.7c-2.62-3.65-6.42-13.72-9.92-10.95-3.07 1.02-0.73 10.51 0.73 11.39l9.19-0.44z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#5e0043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.55 219.45s16.21 9.99 21.53 10.25 22.18-12.97 22.18-12.97",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.11 180.29l3.11-3.89 15.57 7.91 15.82-7.01 3.11 3.25-17.64 12.45-19.97-12.71z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#5e0043"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m128.75 180.08c1.26 1.59 11.32 13.82 13.14 23.94 1.81 10.12-1.04-13.88-1.04-13.88s12.45 6.1 12.84 9.99 5.95-0.26 6.22-0.93l-36.05-23.41 4.89 4.29z",
    stroke: "#474747",
    strokeWidth: 1.25,
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m190.26 179.38s-13.1 17.25-11.54 36.05c-2.7-9-0.52-23.86-0.52-23.86l-2.85 1.82s-2.98 12.71-6.75 14.65c-0.63-1.51-0.51-2.07-0.51-2.07s-4.02 5.18-4.8 5.7 0.26 17.51 0.26 17.51 1.35 12.32 2.9 12.19c-1.77 0.86-3.94 2.21-3.94 2.21l-1.61-32.88 3.68-3.7s4.93-5.96 5.32-11.8c-2.14 1.82-4.54 2.34-4.54 2.34s-0.65 8.3-2.59 9.46c-1.95 1.17-2 3.34-2 3.34l-0.46-10.85 29.95-20.11z",
    stroke: "#474747",
    strokeWidth: 1.25,
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.3 199.35l2.54 51.87",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.4 224.12s5.96 3.51 8.17 14.14c19.45-1.43 25.55 5.45 25.55 5.45s15.95-7.65 23.35-6.23c2.59-5.44 9.98-12.45 9.98-12.45",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.26 173.28l40.04 26.2 36.06-24.25s7.52-4.15 6.87-7.13c-0.64-2.99-3.24-1.82-4.54-1.3-1.29 0.52-37.74 26.33-37.74 26.33l-38.78-24.52s-2.85-0.9-3.37 0.91c-0.52 1.82 1.07 2.85 1.46 3.76z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#b4b6b9"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m191.87 166.48s-10.25-4.35-10.25-0.58c0 3.76 0.29 4.15 1.94 6.57 1.64 2.41-1.26 3.96-1.26 3.96s-0.39-1.06-0.97-2.71c-0.58-1.64-6.09-2.8-6.57-4.73-0.48-1.94 1.16-5.03-2.13-5.41-3.28-0.39-6.47 1.35-7.15 5.12s-4.93 12.56-4.93 12.56l0.58-20c7.22 0.51 20.62 2.09 30.93 3.28-3.09-0.48 1.16 0.2 1.07 1.26-0.29 0.87-1.36 0.96-1.26 0.68z",
    stroke: "#474747",
    strokeWidth: 1.25,
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m155.62 161.45c-1.83 0-11.02 1.06-13.34 2.42-2.32 1.35 3.77 3.47 3 5.31s-0.87 5.51-3.77 4.74c-2.9-0.78-12.66-5.61-12.95-7.25s-2.32-1.74-2.32-1.74 28.03-3.77 29.38-3.48z",
    stroke: "#474747",
    strokeWidth: 1.25,
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.04 159.15l-0.07 24.58",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.11 130.19s-11.23 18.23-11.45 18.79",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.8 129.74s4.89 6.67 4.33 8.56c2 1.56 4.23 7.79 4.23 7.79",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#linearGradient746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.7 128.63s-10.56 14.9-10.23 16.01",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.5 56.748c0 0.79388-1.1339 1.4375-2.5327 1.4375s-2.5327-0.64357-2.5327-1.4375c0-0.79388 1.1339-1.4375 2.5327-1.4375s2.5327 0.64357 2.5327 1.4375z",
    transform: "matrix(1.0161 .31118 -.30126 1.0495 15.15 -41.141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.5 56.748c0 0.79388-1.1339 1.4375-2.5327 1.4375s-2.5327-0.64357-2.5327-1.4375c0-0.79388 1.1339-1.4375 2.5327-1.4375s2.5327 0.64357 2.5327 1.4375z",
    transform: "matrix(-1.0161 .31118 .30126 1.0495 242.3 -41.435)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m254.49 366.13s-3.92 0.74-3.79 1.1c0.12 0.37-11.39 0.74-11.63 0.37-0.25-0.37-1.72 1.96-1.72 1.96l1.84-1.1s2.81 2.93 3.67 2.69-0.37 1.1-0.12 1.35c0.24 0.24 1.1-0.49 1.1-0.49l19.02-0.32-8.37-5.56z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff7000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m261.58 372.05l-15.54 0.45s-3.91 3.55-4.16 4.4c-0.24 0.86 2.57 1.1 2.57 1.1l0.86 2.94 1.96-0.73s13.21 1.96 25.34-0.74c6.12-2.14 7.19-4.71 2.9-6.27-4.28-1.56-13.81-1.09-13.93-1.15z",
    stroke: "#000",
    strokeWidth: 1.25,
    fill: "#ff7000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.37 403.93l27.97-1.25-5.21-4.42 75.65-3.05-2.61-6.01-84.7 3.4 10.19 4.76-22.88 0.68 0.68 2.38-6-0.23s6.68 2.6 6.91 3.74z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#linearGradient794)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.73 249.42c-2.23-1.11-12-2.44-22.89 4.67l0.45 25.11s15.99-8.67 23.77-6.67c-0.45-7.78-0.45-17.77-1.33-23.11z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#linearGradient800)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.074 325.65l-65.956 65.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.47 326.13l-53.532 70.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.08 307.73l-71.455 86.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.474 393.04l6.93-8.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.7 351.22l-27.722 38.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.783 394.48l0.717 14.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.36 364.6l-29.39 36.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.11 398.54l11.95-19.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.65 375.12l-14.34 16.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.35 359.83l-9.8 11.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.68 342.38s-29.871 43.73-29.393 47.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.57 336.65c-0.71 0.47-25.805 33.69-25.805 33.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.331 380.85l-4.541 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.055 394.72l-6.93 9.08"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m81.811 225s-2.024 6.36 0 9.54c2.023 3.18 14.743 28.91 14.743 28.91s8.676-10.7 11.856-10.99c3.18-0.28 1.73 27.76 1.73 27.76s-5.2 4.91-8.38 4.62c-3.182-0.29 7.8 10.99 7.51 20.53s-14.45 56.95-19.654 57.81c-5.203 0.87 2.313-8.67 2.024-11.27s-1.735-0.87-2.891-3.76 1.735-7.23 1.156-10.12c-0.578-2.89-3.18-2.31-3.469-4.33-0.289-2.03 1.735-2.6 1.446-4.92-0.289-2.31-3.469-1.73-3.18-3.76 0.289-2.02 0.578-1.15 0.289-4.91s-0.867 2.6-4.047 2.89-5.782 7.52-5.782 7.52-6.36 8.96-12.72 4.91c3.758 8.1 0.868 11.57-0.578 11.85-1.445 0.29 1.156 6.36-2.313 6.65s2.602 13.59-1.445 14.75c4.336 2.02 0.867 4.62 0.867 4.62s-10.02 0.84-7.805 13.88c-29.487-10.41-43.941-28.33-43.652-46.54 0.2893-18.22 6.071-34.69 20.236-40.76 4.047-15.04 10.985-31.23 10.985-31.23s-1.156-6.65-0.289-10.98c0.868-4.34 4.915-8.67 4.915-8.67s-0.579-10.41-0.289-15.61c0.289-5.21 2.312-7.52 2.601-10.41s-0.867-17.64 2.024-20.24 8.383-2.31 11.274-4.04c2.891-1.74 6.649-4.92 10.407-4.63s6.938 2.89 6.938 2.89 14.166 0 15.033 5.49c0.867 5.5-2.891 7.52-2.891 7.52s2.024 7.81-6.649 15.03z",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "#8a9396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.666 206.45c0 0.95295-1.5933 1.7255-3.5588 1.7255s-3.5588-0.77251-3.5588-1.7255c0-0.95295 1.5933-1.7255 3.5588-1.7255s3.5588 0.77251 3.5588 1.7255z",
    transform: "matrix(.87942 -.47604 .47604 .87942 -90.31 56.579)",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "#cecfcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.68 206.44c0 0.35596-0.44597 0.64453-0.99609 0.64453-0.55013 0-0.99609-0.28857-0.99609-0.64453 0-0.35597 0.44597-0.64453 0.99609-0.64453 0.55013 0 0.99609 0.28856 0.99609 0.64453z",
    transform: "matrix(1.0784 0 0 1.4848 -5.0735 -100.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.971 216s3.511 15.68-0.687 26.5",
    stroke: "#2b2b2b",
    strokeWidth: 0.625,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.051 209.14s6.85 9.06 5.966 20.33",
    stroke: "#2b2b2b",
    strokeWidth: 0.625,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.714 207.15c0.221 0 5.745 4.86 5.524 8.17",
    stroke: "#2b2b2b",
    strokeWidth: 0.625,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.04 205.16s3.757 2.65 4.64 5.3",
    stroke: "#2b2b2b",
    strokeWidth: 0.625,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.272 203.61s-13.479 21.88-11.711 35.58",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.156 202.95s-17.899 10.61-21.213 45.3",
    stroke: "#2b2b2b",
    strokeWidth: 0.625,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.167 209.36l-7.071 5.3",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.314 250.24s9.943-41.32 27.621-47.29",
    stroke: "#2b2b2b",
    strokeWidth: 0.625,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.785 264.16s9.505-11.93 11.715-11.49 1.54 27.62 1.54 27.62-7.07 5.3-8.61 5.08c-1.551-0.22 7.95 12.82 7.73 17.68s-0.44 4.86-0.44 4.86 0-2.87-2.21-7.51-0.89-9.95-15.249-21.66c-3.536-7.29 7.071 4.42 9.279 2.65 2.21-1.76-3.976-17.01-3.755-17.23z",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.893 196.96s-3.994 1.09-4.539 2.72c-0.545 1.64-2.905 3.27-4.176 2.72-1.271-0.54-3.632-2.54-3.632-2.54",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m57.196 210.94s-5.992 5.99-3.086 6.72c2.905 0.72 5.992-4.72 5.992-4.72s0 9.26 2.542 7.8c2.542-1.45 9.986-6.71 9.986-6.71s2.542-0.19 3.087 0c0.545 0.18 6.9 5.62 11.076 3.63-2.36 6.17-5.084 6.9-5.084 6.9s-4.358 5.63-9.986 4.35c-5.629-1.27-7.082-3.63-7.082-3.63s-4.721 0.37-6.174-1.81c-1.452-2.18-1.997-3.45-1.997-3.45s-2.723 2.72-3.45 1.45c-0.726-1.27 0-8.72 4.176-10.53z",
    stroke: "#2b2b2b",
    strokeWidth: 1.25,
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.151 202.59s-11.076-3.27-14.889 2.18c-3.813 5.44-2.905 8.53-0.908 9.07",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.86 202.28c0 1.3059-0.93488 2.3645-2.0881 2.3645s-2.0881-1.0586-2.0881-2.3645 0.93488-2.3645 2.0881-2.3645 2.0881 1.0586 2.0881 2.3645z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.624 230.54s4.517 6.95 9.902 8.86-3.735 3.56-9.12-0.08c-3.908-5.3-2.866-9.12-2.866-9.12s1.042-1.05 2.084 0.34z",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.275 271.54s-12.681-17.63-16.329-18.59c-3.648-0.95 2.779-1.73 6.688 2 3.908 3.73-1.042-6.08-1.042-6.08l10.683 22.67z",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m59.409 373.42c4.863-1.3 26.056 12.16 30.833 15.55 4.777 3.38 14.768 1.21 14.768 1.21s-4.61 2.78-7.472 3.48c-2.866 0.69 8.512 0.69 8.512 0.69s-27.099 7.47-54.632-7.03c-2.519-11.29 5.906-13.81 7.991-13.9z",
    stroke: "#2b2b2b",
    strokeWidth: 1.25,
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.416 275.88s-3.561-0.69-5.385-2.78c-1.824-2.08-4.43-7.21-7.122-9.38-2.693-2.17-16.155-9.55-21.019-9.03s-6.341-0.52-6.949-1.13-2.605 0.26-2.258 2.78c0.348 2.52-3.735 8.08-2.258 10.68 1.476 2.61 8.425 13.2 9.815 13.55 1.389 0.35 0.521 6.17 0.521 6.17s6.166 6.25 7.73 6.6c1.563 0.35 3.126 1.48 2.953 2.95-0.174 1.48-6.775 9.56-6.775 9.56s-7.122 3.73-7.209 5.82c-0.087 2.08 1.737 6.42 7.383 7.81 5.645 1.39 20.845 0.26 21.627-1.04 0.781-1.3 1.997-9.12 1.476-9.9s-4.256-3.13-6.167-2.78c-1.91 0.35-3.647 1.91-3.474 2.26 0.174 0.35-2.692 1.82-2.692 0.43s5.645-7.64 6.166-7.12c0.522 0.52 8.512 1.3 9.989 5.3 1.476 3.99 1.476 6.86 5.645 6.43 4.169-0.44 9.987-4.26 10.507-12.25s-4.687-13.38-5.99-14.16-5.646-3.39-5.993-4.6c-0.348-1.22-1.216-5.21-0.521-6.17z",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.286 311.15s13.463-3.48 16.937-3.39c3.474 0.08 16.589 6.16 20.411 9.9 3.821 3.73 11.638 12.59 16.763 11.81 5.124-0.78 6.601-1.82 6.601-1.82l-1.998 3.82s-4.169 1.13-6.253 0.61c-2.085-0.52-6.167-1.83-10.249-5.82-4.082-4-16.676-14.77-27.359-13.99-10.684 0.79-16.85 11.3-16.85 11.3s0.087-5.13 0.521-6.26-2.258 2.43-2.258 2.43l3.734-8.59z",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.88 321.57c0.087 0.08 3.388 0.95 8.946 0.95 5.559 0 8.512-2.43 8.512-2.43l-0.347-2.17 0.868-3.04s4.256 4.34 4.169 5.21-1.737 1.22-1.737 1.22l-0.608-2.09-1.476 1.83s-8.078 6.42-12.507 5.47c-4.43-0.96-8.512-3.82-7.383-4.52 1.129-0.69 1.737-0.43 1.563-0.43z",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.251 332.95s-4.864-0.09-7.035 0.95-2.953 2.35-4.43 2.17c-1.476-0.17-2.605-2.08-2.171-2.86 0.608-1.22 3.474-2.78 8.946-2.35 5.472 0.44 4.69 2.09 4.69 2.09z",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.275 346.15c0-0.26-0.348-7.12-3.04-9.9-2.693-2.78-5.993-2.78-7.47-2.44-1.476 0.35 5.472 3.39 6.167 5.39s2.953 7.56 2.345 8.95c-0.608 1.38-1.737-3.91-5.993-5.39s-10.162-0.69-8.946 1.22 5.993 0.17 8.425 4.25 4.256 8.43 4.256 8.43l0.782-2.96 2.171-0.6 0.26-5.65 1.043-1.3z",
    stroke: "#2b2b2b",
    strokeWidth: "1pt",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m58.801 368.38l-4.43-8.86s-1.39-5.64-5.124-7.21c-3.735-1.56-8.686-1.3-8.773 0.61s7.991 4.34 8.512 5.39c0.521 1.04 0.261 2.78-0.434 2.86-0.695 0.09-4.256-1.3-6.08-0.87-1.824 0.44-2.866 2.78-5.559 2.09-2.692-0.7-4.951-9.29-3.908-10.16 1.042-0.87-1.998 1.56-2.606-0.7s0.869-9.29-0.174-10.16c-1.042-0.87-6.079-3.91-6.166-4.52-0.087-0.6 0.26-34.56 28.662-6.42-12.16-14.42-16.937-12.86-19.195-12.94-1.65 0-12.681 0.95-15.46 15.02-2.78 14.07-6.08 5.3-6.08 5.3s-0.608 6.08 2.345 7.82c2.953 1.73-1.39 6.77-1.39 6.77s-5.2978-12.94-4.5161-18.59c-1.0423 4.52-0.9554 15.72 5.7321 27.97 7.817 8.25 15.2 15.9 34.829 24.49 10.336-15.8 9.815-17.71 9.815-17.89z",
    stroke: "#2b2b2b",
    strokeWidth: 1.25,
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m40.214 368.47s5.732 0.69 7.295 3.65c1.564 2.95 2.259 7.47 2.259 7.47 0.955-1.91 1.389-3.56 3.3-4.95s3.301-1.57 3.214-2.61-6.08-7.38-9.12-7.73-8.338 3.3-8.338 3.3-0.955 1.39 1.39 0.87z",
    stroke: "#2b2b2b",
    strokeWidth: 1.25,
    fill: "#8a9396"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.25,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.307 383.41s14.856 6.77 39.324 7.21",
    stroke: "#8a9396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.9 314.45s-1.27 12.47-10.861 37.07",
    stroke: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.99 322.12s-2.879 8.95-10.869 15.66",
    stroke: "#2b2b2b",
    strokeLinecap: "butt",
    strokeWidth: "1pt"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGs);
export default __webpack_public_path__ + "static/media/gs.a72696cf79bb09dc341398aedd11c274.svg";
export { ForwardRef as ReactComponent };